$('.js-clear-field').on('click', function(event) {
  event.preventDefault();

  $(this).siblings('input').val('').focus();
});